<div class="w-full md:w-1/2 lg:w-1/3 m-auto rounded-lg border border-gray-500 p-2 mt-2">
  <div class="text-lg font-bold mb-2">Invite User</div>
  <form class="flex flex-col" [formGroup]="formGroup" autocomplete="off" (ngSubmit)="invite()">
    <mat-checkbox formControlName="isDriver" color="primary">This user is a Driver</mat-checkbox>
    <mat-checkbox formControlName="isAdmin" color="primary">This user is an Admin</mat-checkbox>
    <div class="text-gray-700">LoHi Logistics will send a text invite to this user</div>
    <mat-form-field>
      <mat-label>Phone Number</mat-label>
      <ngx-mat-intl-tel-input
        [preferredCountries]="['us']"
        [enablePlaceholder]="true"
        [enableSearch]="true"
        format="national"
        name="phoneNumber"
        formControlName="phoneNumber"
      ></ngx-mat-intl-tel-input>
      <mat-error *ngIf="formGroup.controls['phoneNumber'].hasError('required')">Phone Number is required</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Full Legal Name</mat-label>
      <input matInput formControlName="name" />
      <mat-error *ngIf="formGroup.controls['name'].hasError('required')">Name is required</mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="formGroup.get('email').enabled">
      <mat-label>Company Email</mat-label>
      <input matInput formControlName="email" type="email" ngModel email />
      <mat-error *ngIf="formGroup.controls['email'].hasError('required'); else invalidEmail"
        >Company Email is required
      </mat-error>
      <ng-template #invalidEmail>
        <ng-container *ngIf="formGroup.controls['email'].hasError('email')">
          <mat-error>Invalid email</mat-error>
        </ng-container>
      </ng-template>
    </mat-form-field>
    <mat-form-field *ngIf="formGroup.get('password').enabled">
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="password" />
      <mat-error *ngIf="formGroup.controls['password'].hasError('required')">Password is required</mat-error>
    </mat-form-field>
    <div *ngIf="formGroup.get('cut').enabled">
      <div class="font-bold py-1">Driver Earnings</div>
      <div class="grid">
        <mat-form-field>
          <mat-label>Load Earnings Percentage</mat-label>
          <input matInput formControlName="cut" type="number" autocomplete="off" />
          <div matSuffix>%</div>
          <mat-error *ngIf="formGroup.controls['cut'].hasError('required')"
            >Loads Earning Percentage is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="text-gray-700 text-sm pb-2">
        Used to show the driver how much they can expect to earn with each load. Calculated as a percent of that load's
        revenue (less fuel surcharge).
      </div>
    </div>
    <mat-form-field *ngIf="formGroup.get('cdl').enabled">
      <mat-label>CDL Number</mat-label>
      <input matInput formControlName="cdl" type="text" />
      <mat-error *ngIf="formGroup.controls['cdl'].hasError('required')">CDL Number is required</mat-error>
    </mat-form-field>
    <ng-container *ngIf="'eldManagement'">
      <mat-form-field *ngIf="formGroup.get('eldGroupId').enabled">
        <mat-label>ELD Group</mat-label>
        <mat-select formControlName="eldGroupId">
          <mat-option>No Group</mat-option>
          <mat-option *ngFor="let group of eldGroups$ | async; trackBy: 'id' | trackByKey" [value]="group.id"
            >{{ group.name }} ({{ group.providerName | uppercase }})</mat-option
          >
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-container *lohiFeatureFlag="'driverConfirmsMove'">
      <div class="border-red-500 border-2 rounded p-2 mb-2" *ngIf="formGroup.get('isDriver').value">
        <div class="text-xl font-bold text-center bg-red-400 rounded my-1 py-1">Please Note</div>
        We will send this driver a text asking them if they want to move from their current company into your company.
        Let them to know that they will not be moved until they respond to the text message with the word "yes".
        <div class="font-bold mt-1">Sample Conversation</div>
        <div class="border border-gray-700 p-1 my-1">
          <div class="bg-gray-500 rounded-lg float-left w-4/5 p-1 px-2 mb-1">
            You have been invited to drive for {{ companyName$ | async }}, respond "yes" if you would like to move or
            "no" if you want to stay with your current carrier
          </div>
          <div class="bg-blue-600 text-white float-right w-4/5 rounded-lg p-1 px-2 mb-1">yes</div>
          <div class="bg-gray-500 rounded-lg float-left w-4/5 p-1 px-2">Thank you for confirming</div>
          <div class="clearfix"></div>
        </div>
        <div class="font-bold">Your driver will not be moved until they confirm they wish to move via text</div>
      </div>
    </ng-container>

    <button
      type="submit"
      mat-raised-button
      color="primary"
      [disabled]="!formGroup.get('isAdmin').value && !formGroup.get('isDriver').value"
    >
      Invite User
    </button>
  </form>
</div>
